<h1 mat-dialog-title>
  <span>{{ 'fileInfoDialog.header' | translate | interpolate:file.name }}</span>
  <button *ngIf="form.dirty" type="button" mat-icon-button [matTooltip]="'fileInfoDialog.resetInfo' | translate"
    matTooltipPosition="right" (click)="reset()" class="xs">
    <mat-icon>restore</mat-icon>
  </button>
</h1>
<button data-id="modal-close-button" mat-icon-button (click)="cancel()" class="mat-dialog-close-button">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="flex-row" test-id="file-name">
      <p class="editor-label">{{ 'fileInfoDialog.rows.fileName' | translate }}</p>
      <div *ngIf="writable && canRenameFile && permissions.renameFiles; else readonlyFilename" class="editor-field">
        <mat-form-field appearance="outline" class="full-width">
          <input type="text" matInput formControlName="name" [placeholder]="file.name" autocomplete="off">
          <button *ngIf="form.get('name').dirty" type="button" mat-icon-button matSuffix
            (click)="form.get('name').reset(file.name)" [matTooltip]="'common.actions.reset' | translate">
            <mat-icon>restore</mat-icon>
          </button>
          <mat-error
            *ngIf="form.get('name').hasError('required')">{{ 'fileInfoDialog.errors.required' | translate }}</mat-error>
          <mat-error
            *ngIf="form.get('name').hasError('pattern')">{{ 'fileInfoDialog.errors.filename' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <ng-template #readonlyFilename>
        <p class="editor-field">{{ file.name }}</p>
      </ng-template>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="'fileInfoDialog.rows.fileName' | translate"
          fieldKey="name"></fw-action-menu>
      </p>
    </div>
    <div *ngIf="file.version" class="flex-row" test-id="file-version">
      <p class="editor-label">{{ 'fileInfoDialog.rows.fileVersion' | translate }}</p>
      <p class="editor-field">
        {{ file.version }}
        <a (click)="versionHistory()"
          class="version-history">{{ 'fileInfoDialog.rows.viewVersionHistory' | translate }}</a>
      </p>
      <p class="editor-action-menu"></p>
    </div>
    <div *ngIf="file.restored_from" class="flex-row" test-id="file-restored-from">
      <p class="editor-label">{{ 'fileInfoDialog.rows.restoredFromVersion' | translate }}</p>
      <p class="editor-field">{{ file.restored_from }}</p>
      <p class="editor-action-menu"></p>
    </div>
    <div class="flex-row" test-id="origin-type-id">
      <p class="editor-label">
        {{ 'fileInfoDialog.rows.originActionBy' | translate | interpolate:(originAction | titlecase) }}</p>
      <p class="editor-field">
        {{ origin.type | titlecase }}: {{ origin.id }}
      </p>
      <p class="editor-action-menu"></p>
    </div>
    <div class="flex-row" test-id="file-created">
      <p class="editor-label">
        {{ 'fileInfoDialog.rows.originActionAt' | translate | interpolate:(originAction | titlecase) }}</p>
      <p class="editor-field">
        {{ file.created | date: 'yyyy-MM-dd HH:mm:ss' }}
      </p>
      <p class="editor-action-menu"></p>
    </div>
    <div *ngIf="file.modified" class="flex-row" test-id="file-modified">
      <p class="editor-label">{{ 'fileInfoDialog.rows.modifiedAt' | translate }}</p>
      <p class="editor-field">
        {{ file.modified | date: 'yyyy-MM-dd HH:mm:ss' }}
      </p>
      <p class="editor-action-menu"></p>
    </div>
    <div class="flex-row" test-id="file-size">
      <p class="editor-label">{{ 'fileInfoDialog.rows.size' | translate }}</p>
      <p class="editor-field">{{ file.size | storageUnit: 2 }}</p>
      <p class="editor-action-menu"></p>
    </div>
    <div *ngIf="file.deid_log_id" class="flex-row" test-id="file-deid-log-id">
      <p class="editor-label">{{ 'fileInfoDialog.rows.deidLogId' | translate }}</p>
      <p class="editor-field">{{ file.deid_log_id }}</p>
      <p class="editor-action-menu"></p>
    </div>
    <div class="flex-row" test-id="file-type">
      <p class="editor-label">{{ 'fileInfoDialog.rows.type' | translate }}</p>
      <div *ngIf="writable && permissions.changeType; else readonlyFiletype" class="editor-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-select formControlName="type">
            <mat-option *ngFor="let fileType of fileTypes" [value]="fileType">
              {{ fileType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-template #readonlyFiletype>
        <p class="editor-field">{{ file.type }}</p>
      </ng-template>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="'fileInfoDialog.rows.type' | translate"
          fieldKey="type"></fw-action-menu>
      </p>
    </div>
    <div class="flex-row" test-id="file-mimetype">
      <p class="editor-label">{{ 'fileInfoDialog.rows.mimeType' | translate }}</p>
      <p class="editor-field">{{ file.mimetype }}</p>
      <!-- <div *ngIf="writable && permissions.changeType" class="editor-field">
        <mat-form-field  appearance="outline" class="full-width">
          <input type="text" matInput formControlName="mimetype" [placeholder]="file.mimetype" autocomplete="off">
          <button *ngIf="form.get('mimetype').dirty" type="button" mat-icon-button matSuffix
            (click)="form.get('mimetype').reset(file.mimetype)" [matTooltip]="'common.actions.reset' | translate">
            <mat-icon>restore</mat-icon>
          </button>
          <mat-error *ngIf="form.get('mimetype').hasError('required')">{{ 'fileInfoDialog.errors.required' | translate }}</mat-error>
          <mat-error *ngIf="form.get('mimetype').hasError('pattern')">{{ 'fileInfoDialog.errors.mimetype' | translate }}</mat-error>
        </mat-form-field>
      </div> -->
      <p class="editor-action-menu"></p>
    </div>
    <div *ngIf="file.zip_member_count" class="flex-row" test-id="file-zip-member-count">
      <p class="editor-label">{{ 'fileInfoDialog.rows.zipMemberCount' | translate }}</p>
      <p class="editor-field">{{ file.zip_member_count }}</p>
      <p class="editor-action-menu"></p>
    </div>
    <div class="flex-row" test-id="file-modality">
      <p class="editor-label">{{ 'fileInfoDialog.rows.modality' | translate }}</p>
      <div *ngIf="writable && permissions.modifyClassification; else readonlyModality" class="editor-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-select class="outline" formControlName="modality" placeholder="Modality">
            <mat-option *ngFor="let option of modalityOptions" [value]="option.value">
              {{ option.label || option.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-template #readonlyModality>
        <p class="editor-field">{{ getModalityLabel(file.modality) }}</p>
      </ng-template>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="'fileInfoDialog.rows.modality' | translate"
          fieldKey="modality"></fw-action-menu>
      </p>
    </div>
    <!-- Classifications -->
    <div formGroupName="classification" class="flex-row" *ngFor="let dimension of classificationDimensions">
      <div class="editor-label">
        <p style="margin-left: 10px">{{ dimension.dimension }}</p>
      </div>
      <div *ngIf="writable && permissions.modifyClassification; else readonlyClassifications" class="editor-field">
        <mat-form-field appearance="outline" color="primary" class="full-width">
          <mat-select multiple formControlName="{{ dimension.dimension }}" placeholder="Select">
            <mat-option *ngFor="let option of dimension.options" [value]="option.value">
              {{ option.label || option.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-template #readonlyClassifications>
        <p class="editor-field">{{ file.classification[dimension.dimension]?.join(', ') }}</p>
      </ng-template>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="dimension.dimension"
          [fieldKey]="'classification.' + dimension.dimension"></fw-action-menu>
      </p>
    </div>
    <!--Custom Classifications-->
    <div class="flex-row">
      <div class="editor-label">
        <p style="margin-left: 10px">{{ 'fileInfoDialog.rows.customClassification' | translate }}</p>
      </div>
      <div *ngIf="writable && permissions.modifyClassification; else readonlyCustomClassification" class="editor-field">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="custom"
            placeholder="{{ 'fileInfoDialog.rows.customClassification' | translate }}" />
        </mat-form-field>
      </div>
      <ng-template #readonlyCustomClassification>
        <p class="editor-field">{{ customClassification }}</p>
      </ng-template>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="'fileInfoDialog.rows.customClassification' | translate"
          fieldKey="classification.Custom"></fw-action-menu>
      </p>
    </div>
    <!-- File Tags -->
    <div class="flex-row">
      <p class="editor-label">{{ 'fileInfoDialog.rows.tags' | translate }}</p>
      <div class="editor-field">
        <fw-tags [autoSave]="false" [file]="file" formControlName="tags" [useAsInlineField]="true"
          [writable]="writable && permissions.modifyTags">
        </fw-tags>
      </div>
      <p class="editor-action-menu">
        <fw-action-menu [auditable]="file" [fieldLabel]="'fileInfoDialog.rows.tags' | translate"
          fieldKey="tags"></fw-action-menu>
      </p>
    </div>
  </form>
  <!-- Custom Information -->
  <info-edit #customInfo [file]="file" [writable]="writable && permissions.modifyInfo" [container]="container"
    [info]="file.info" [changeManagerEnabled]="false" [displaySave]="false">
  </info-edit>
</div>
<div *ngIf="dirty" mat-dialog-actions align="end">
  <button mat-stroked-button test-id="cancel" color="primary" (click)="cancel()">
    {{ 'common.actions.cancel' | translate }}
  </button>
  <div [matTooltip]="valid ? null : ('fileInfoDialog.saveInvalid' | translate)" matTooltipPosition="above">
    <button mat-flat-button color="primary" test-id="save" (click)="save()" [disabled]="!valid">
      {{ 'common.actions.save' | translate }}
    </button>
  </div>
</div>
<div *ngIf="!dirty" mat-dialog-actions align="end">
  <button mat-stroked-button test-id="close" color="primary" (click)="cancel()">
    {{ 'common.actions.close' | translate }}
  </button>
</div>
